
import _ from 'lodash'
import { useEffect, useCallback, useState } from 'react'
import { connect } from 'react-redux'

import { onlyNumbers } from '../../../../lib/Form'
import VI from '../../../../lib/IssueMapping/vitals'
import { IGAO } from '../../../igao'
import * as Card from '../../../shared/card'
import IssueQueuer from '../../../shared/IssueQueuer'
import { CircularProgress } from '../../../shared/NarusMaterial'
import PalliativePerformance from '../PalliativePerformance'

import * as Actions from './actions'
import VitalsForm from './form'

const FHIR_RESOURCE_TYPE = 'Vitals'

function Vitals ({
  dispatch,
  patientId,
  encounter,
  vitals,
  practitionerId
}) {
  const [ open, setOpen ] = useState(true)

  const handleIssueDataRange = (value, lowerBound, upperBound) => {
    let triggerValue
    if (value < lowerBound || value > upperBound) {
      triggerValue = value < lowerBound ? 'below' : 'above'
    }
    return triggerValue
  }

  const resetForm = useCallback(() => {
    const encounterId = _.get(encounter, 'document.context_id')
    dispatch(Actions.getVitals(patientId, encounterId, FHIR_RESOURCE_TYPE))
  }, [ dispatch, encounter, patientId ])

  useEffect(() => {
    if (encounter?.document?.context_id) {
      resetForm()
    }
  }, [ encounter, resetForm ])

  const queueIssues = data => {
    const iq = new IssueQueuer({
      dispatch,
      patientId,
      practitionerId,
      encounterId: _.get(encounter, 'document.context_id')
    })

    iq.queueIssues({
      mapping: VI,
      currentForm: data,
      existingForms: undefined
    })
  }

  const handleSubmit = data => {
    const questionField = [
      {
        text: 'Were vitals reported by patient?',
        key: 'reportedByPatient'
      },
      {
        text: 'Were vitals obtained via medical record?',
        key: 'obtainedViaMedRec'
      }
    ]
    const questionnaireResponseBody = {
      resourceType: 'QuestionnaireResponse',
      status: 'completed'
    }

    questionnaireResponseBody.item = questionField.reduce(
      (acc, item) =>
        acc.concat({
          text: item.text,
          answer: [
            {
              valueString: data[item.key] || ''
            }
          ]
        }),
      []
    )

    for (const k in data) {
      data[k] = Number(onlyNumbers(data[k]))
    }
    data.bmiIssue = handleIssueDataRange(data.BMI, 18.5, 30)
    data.systolicIssue = handleIssueDataRange(data.systolic, 90, 140)
    data.diastolicIssue = handleIssueDataRange(data.diastolic, 65, 90)
    data.temperatureIssue = handleIssueDataRange(data.temperature, 97.8, 99.9)
    data.pulseIssue = handleIssueDataRange(data.pulse, 60, 100)
    data.respiratoryRateIssue = handleIssueDataRange(
      data.respiratoryRate,
      12,
      18
    )
    data.pulseOxygenIssue = handleIssueDataRange(data.pulseOxygen, 90, 100)

    const encounterId = _.get(encounter, 'document.context_id')
    queueIssues(data)
    dispatch(
      Actions.updateVitals(
        data,
        questionnaireResponseBody,
        patientId,
        encounterId,
        FHIR_RESOURCE_TYPE
      )
    )
  }

  return (
    <div className='main'>
      <Card.Card>
        <Card.Header
          expandableValue={open}
          expandableOnChange={setOpen}
        >
          <h2>Vitals</h2>
        </Card.Header>
        <Card.ExpandableWrapper
          open={open}
          style={{ padding: '0 1rem 1rem' }}
        >
          {vitals.loading
            ? (
              <CircularProgress />
            )
            : (
              <VitalsForm
                formKey='vitals'
                initialValues={vitals.vitals}
                onSubmit={handleSubmit}
                cancel={resetForm}
              />
            )}
        </Card.ExpandableWrapper>
      </Card.Card>
      <div className='component'>
        {encounter ? <PalliativePerformance /> : <CircularProgress />}
      </div>
      <IGAO path='vitals' />
    </div>
  )
}

const mapStateToProps = redux => ({
  vitals: redux.vitals,
  encounter: redux.encounter?.encounter,
  patientId: redux?.globalVars?.params?.id,
  practitionerId: redux.auth.profile.sub
})

export default connect(mapStateToProps)(Vitals)
